// Platform legal routes, kept apart from the legal texts so the app shell and the landing page don't bundle them.
// Platform legal pages exist in every language at marketingPath(lang, kind): /legal, /es/aviso-legal, /de/legal …
// (also listed in backend/server.py MARKETING_PAGES).
import { isLang, marketingPath } from "@/i18n";

export const LEGAL_KINDS = ["legal", "privacy", "cookies", "terms", "dpa"];
export const legalPath = (kind, lang) => marketingPath(isLang(lang) ? lang : "en", kind);
